"use client"

import cn from "classnames"

import { VideoPlayer } from "~/components/primitives/Asset/VideoPlayer"
import { getModuleConfigProps } from "~/utils/moduleConfig"

import type { VideoInterface } from "./Video.interface"
import s from "./Video.module.scss"

type Props = VideoInterface & {
  moduleIndex: number
}

export const VideoView = ({
  id,
  moduleIndex,
  thumbnailVideo,
  posterImage,
  videoSource,
  videoTitle,
  insetOption,
  config,
}: Props) => {
  const configProps = getModuleConfigProps(config)

  if (!videoSource?.url) return null

  return (
    <section
      className={cn(`stack-module-${moduleIndex}`, s.video)}
      aria-label={`Video: ${videoTitle}`}
      data-module="video"
      data-inset-option={insetOption}
      {...configProps}
      style={{
        ...configProps.style,
      }}
    >
      <div className={cn("container", "default-grid")}>
        <div className={s.wrapper}>
          <div className={s.foreground}>
            <div className={s.deviceFrame}>
              <VideoPlayer
                moduleId={id}
                thumbnailVideo={thumbnailVideo}
                posterImage={posterImage}
                videoSource={videoSource}
                videoTitle={videoTitle}
                config={config}
                className={s.iframe}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
